import { EntityBase } from './EntityBase';
import { Reference } from './Reference';
import { TypeReferenceRelation } from './TypeReferenceRelation';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ReferenceRelation extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   referenceId: number;
   relatedReferenceId: number;
   typeReferenceRelationId: string;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   reference: Reference;
   relatedReference: Reference;
   typeReferenceRelation: TypeReferenceRelation;
}

